import cc from 'store/util/createReduxConstant';

export const UPDATE_CURRENT_PAGE = cc('MY_INVENTORY/UPDATE_CURRENT_PAGE');
export const SET_FILTER = cc('MY_INVENTORY/SET_FILTER');
export const RESET_FILTER = cc('MY_INVENTORY/RESET_FILTER');
export const SET_DEFAULT_TYPES = cc('MY_INVENTORY/SET_DEFAULT_TYPES');
export const SET_SORT = cc('MY_INVENTORY/SET_SORT');
